import { DialogTitle, TextField } from '@mui/material';
import styled from 'styled-components';

export const AdminLandingModalWrapper = styled.div`
`;

export const TitleFont = styled(DialogTitle)`
    font-size: 1.5em;
    font-weight: bold !important;
    display: flex;
    justify-content: space-between;
    gap: 0.4em;
    line-height: 1.5em;
    cursor: move;
`;

export const StyledTextField = styled(TextField)`
    width: 100%;
`;

export const ItemRow = styled.div`
    width: 100%;
    display: flex;
    gap: 1em;
`;